import CommonHelmet from '@src/components/CommonHelmet';
import CompanyGuard from '@src/components/guard/CompanyGuard';
import { COMPANY_ROLE } from '@src/enum/companyRoleEnum';
import CompanyUserEditForm from '@src/features/company/company-user/CompanyUserEditForm';
import CompanyDefaultLayout from '@src/layouts/company/CompanyDefaultLayout';

function CompanyUserEdit() {
  return (
    <CompanyGuard canRoles={[COMPANY_ROLE.ADMIN]}>
      <CompanyDefaultLayout pageName='users'>
        <CommonHelmet />
        <CompanyUserEditForm />
      </CompanyDefaultLayout>
    </CompanyGuard>
  );
}

export default CompanyUserEdit;
